import {
  CallButton,
  EndCallButton,
  IncomingCallContactDisplay,
  IncomingCallNumber,
  IncomingCallText,
  IncomingScreenWrapper,
  Row,
  TruncateContactNameString,
} from "../Components";
import { ScreenProps } from "../../types/ScreenTypes";
import { EndCallSvg, StartCallSvg } from "../Icons";
import { formatPhoneNumber } from "../../utils/phoneNumberUtils";
import { ANSWER_CALL, END_CALL } from "../../constants/buttonIds";
import { useCallback, useEffect, useRef, useState } from "react";
import { io, Socket } from "socket.io-client";
import { KeypadPopover } from "../Keypad";
import KeypadScreen from "./KeypadScreen";
import { urls } from "../api/api";
import axios from "axios";

function IncomingScreen({
  handleNextScreen,
  incomingNumber,
  handleCallEnded,
  cti,
  startTimer,
  incomingContactName,
  handlePreviousScreen,
  handleKeypadScreen,
  setCallStatus,
}: ScreenProps) {
  const userInformation = localStorage.getItem("userInformation");
  const UserInfo = userInformation ? JSON.parse(userInformation) : {};
  const socketRef = useRef<Socket | null>(null);
  const hasPosted = useRef(false);
  const [callconnect, setCallConnect] = useState("PENDING");

  // useEffect(() => {
  //   if (socketRef.current && socketRef.current.connected) {
  //     console.log("Socket is already connected, skipping new connection.");
  //     return;
  //   }

  //   const socket: Socket = io(`${urls.socket}`, {
  //     path: "/ws/hubspot",
  //     transports: ["websocket"],
  //   });

  //   socketRef.current = socket;

  //   socket.on("connect", () => {
  //     console.log("Connected to hubspot socket.io server");
  //   });

  //   socket.on("disconnect", () => {
  //     console.log("Disconnected from hubspot socket.io server IncomingScreen");
  //   });

  //   const handleNewCall = (payload: any) => {
  //     const data = payload.payload;
  //     if (
  //       data.Status === "Picked" &&
  //       data.Status !== "ANSWER" && data.Direction=== "IVR" &&
  //        data.DialWhomNumber.slice(-10) ===
  //           UserInfo.mobile_no.slice(-10)
  //     ) {
  //       const callStartTime = Date.now();
  //       startTimer(callStartTime);
  //       cti.callAnswered();
  //       handleNextScreen();
  //     } else if (
  //       data.Status === "CallQueue" &&
  //       data.Status !== "ANSWER" && data.Direction=== "IVR" &&
  //        data.DialWhomNumber.slice(-10) ===
  //           UserInfo.mobile_no.slice(-10)
  //     ) {
  //       setCallStatus("CANCELED");
  //       cti.callEnded({ callEndStatus: "CANCELED" });
  //       handleCallEnded();
  //     }
  //   };

  //   socket.on("message", handleNewCall);

  //   return () => {
  //     if (socketRef.current && socketRef.current.connected) {
  //       socketRef.current.off("message", handleNewCall);
  //       socketRef.current.disconnect();
  //       console.log("Socket disconnected during cleanup");
  //     }
  //   };
  // }, []);
  useEffect(() => {
    const getData = async () => {
      const response = await axios.get(urls.liveCall, {
        params: { authcode: UserInfo.authcode },
      });

      if (
        response.data.live_calls?.length > 0 &&
        response.data.live_calls[0].callstatus !== "Transferring Call to Agent"
      ) {
        setCallConnect("CONNECT");
        const callStartTime = Date.now();
        startTimer(callStartTime);
        handleNextScreen();
      }

      if (response.data.live_calls.length === 0 && !hasPosted.current) {
        hasPosted.current = true;
        handleKeypadScreen();
        localStorage.removeItem("incomingContactName");
        localStorage.removeItem("outgoing");
        localStorage.removeItem("isFromWindows");
        localStorage.removeItem("incomingCall");
        localStorage.removeItem("INCOMING_CALL");
        localStorage.removeItem("thirdParty");
      }
    };

    const interval: any = setInterval(getData, 2000);
    return () => clearInterval(interval);
  }, [callconnect]);

  const onEndIncomingCall = async () => {
    setCallStatus("CANCELED");
    handleCallEnded();
  };

  return (
    <IncomingScreenWrapper>
      <div style={{ textAlign: "center" }}>
        <IncomingCallText>Incoming call...</IncomingCallText>
        {incomingContactName ? (
          <>
            <IncomingCallContactDisplay>
              <TruncateContactNameString>
                {incomingContactName}
              </TruncateContactNameString>
            </IncomingCallContactDisplay>
            <IncomingCallNumber>
              {formatPhoneNumber(incomingNumber)}
            </IncomingCallNumber>
          </>
        ) : (
          <IncomingCallContactDisplay>
            {formatPhoneNumber(incomingNumber)}
          </IncomingCallContactDisplay>
        )}
        <EndCallButton
          style={{ marginTop: "180px" }}
          use="primary"
          onClick={onEndIncomingCall}
          aria-label="cancel-call"
          data-test-id={END_CALL}
        >
          {EndCallSvg}
        </EndCallButton>
      </div>
    </IncomingScreenWrapper>
  );
}

export default IncomingScreen;
